export default __webpack_public_path__ + "static/media/cx_cover_tln2.5997dbb8.jpg";